import { Component, inject, OnInit } from "@angular/core";
import { IPage } from "@models/pagination/page";
import { ISportDto } from "@models/sport-dto";
import { SportService } from "@shared/services/sport.service";
import { BaseComponent } from "src/app/core/utilities/base-component/base-component";

@Component({
  selector: 'sigecom-step-parameterization',
  templateUrl: './sport.parameterization-list.component.html',
})

export class SportParameterizationComponentList extends BaseComponent implements OnInit {

  sportsPage?: IPage<ISportDto>;


  #sportService = inject(SportService);

  ngOnInit(): void {
    this.loadAllSports();
  }

  private loadAllSports(page?: number): void {
    this.#sportService.getAllSports(page, 10).subscribe({
      next: (res) => {
        this.sportsPage = res;
      }
    });
  }

  protected navigateToEdit(event: ISportDto | any) {
    this.router.navigate(["parametrizacao-esporte", "editar", event.espNrId]).then();
  }

  onPageChange(page: number) {
    this.loadAllSports(page);
  }
}